export const getVocabulary = (
  params: {
    label?: string;
    usagesFields?: string;
  } = {},
) => /* GraphQL */ `
    query ${params.label ?? "GetVocabulary"}(
      $input: ModelGetInput!
    ) {
      getVocabulary(input: $input) {
        id
        sk
        schemaVersion
        workspaceId
        createdAt
        description
        isDeleted
        name
        subject
        tags { key type value }
        updatedAt
        ${
          params.usagesFields == null
            ? ""
            : /* GraphQL */ `
              usages {
                count
                items {
                  id
                  sk
                  tags { key type value }
                  item {
                    ${params.usagesFields}
                  }
                }
              }
            `
        }
      }
    }
  `;

export const getVocabularySimple = /* GraphQL */ `
  query GetVocabulary($input: ModelGetInput!) {
    getVocabulary(input: $input) {
      id
      sk
      schemaVersion
      workspaceId
      createdAt
      description
      isDeleted
      name
      subject
      tags {
        key
        type
        value
      }
      updatedAt
    }
  }
`;
